import { useMemo } from 'react';
import { RiseLoader } from 'react-spinners';
import useMain from '../../../../hooks/useMain';
import getCSSVars from '../../../../utils/getCSSVars';
import userRank from '../../../../utils/userRank';
import Charts from './downlines/charts';
import Search from './downlines/search';
import UsersSection from './downlines/usersSection';
import OnlyPlanners from './onlyPlanners';

const Downlines = () => {
	const { userDownlines, userData, initData } = useMain();
	const allUsers = useMemo(() => {
		const merged = userDownlines ? [...userDownlines.right, ...userDownlines.left] : [];
		const sorted = merged.sort((a, b) =>
			a.currentPackageValue > b.currentPackageValue ? -1 : 1
		);
		for (const i in sorted) {
			if (!sorted[i].card) {
				sorted[i].currentPackageValue = 0;
				sorted[i].L = { totalValue: 0 };
				sorted[i].R = { totalValue: 0 };
			}
			sorted[i].userRank = userRank(sorted[i], initData).title;
			sorted[i].balance = Math.min(sorted[i].L.totalValue, sorted[i].R.totalValue) / 1e6;
		}
		return sorted;
	}, [userDownlines, initData]);

	if (userData.class !== 'planner') return <OnlyPlanners />;

	return (
		<>
			{userDownlines ? (
				<>
					<UsersSection allUsers={allUsers} />
					<Search allUsers={allUsers} />
					<Charts allUsers={allUsers} />
				</>
			) : (
				<div className='h-50 d-flex justify-content-center align-items-center my-5'>
					<RiseLoader
						speedMultiplier={0.8}
						loading={true}
						size={20}
						sizeUnit={'px'}
						color={getCSSVars('text-set3')}
					/>
				</div>
			)}
		</>
	);
};

export default Downlines;
